/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RulesIcon extends BaseIcon {
  getChildren = () => [ <path d="M1,12h9V11H3V3A2,2,0,0,1,5,1h8a3,3,0,0,1,3,3H14V3H13v.94h0V12c0,1.1.14,3-3.46,3H4a3,3,0,0,1-3-3H3v1H1M16,5H14V4h2Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
